import axios from './axios';
import { DATA_PER_PAGE } from '../constants/Values';

export const getCarrierList = (pageNumber, size = DATA_PER_PAGE) =>
  axios.post('/transportation/carriers/search', {
    pagination: {
      pageNumber,
      size,
      sort: [
        {
          direction: 'ASC',
          property: 'name',
        },
      ],
    },
  });

export const getCarrierDetails = carrierId => axios.get(`transportation/carriers/${carrierId}`);

export const createCarrier = carrier => axios.post('/transportation/carriers', carrier);

export const updateCarrier = (carrierId, carrier) =>
  axios.put(`/transportation/carriers/${carrierId}`, carrier);

export const removeCarrier = carrierId => axios.delete(`/transportation/carriers/${carrierId}`);
